<template>
  <AttrBase
    :label="label"
    :disabled="disabled"
    @mousemove="() => (hover = true)"
    @mouseleave="() => (hover = false)"
  >
    <div>
      <a-switch
        v-model:checked="_val"
        :disabled="disabled"
        @change="onChange"
      />
    </div>
  </AttrBase>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: Boolean,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const _val = ref<boolean>();
watch(
  () => props.value,
  (v) => {
    _val.value = !!v;
  },
  { immediate: true }
);

const emit = defineEmits<{
  (event: 'change', val: typeof _val.value): void;
}>();

const onChange = (v: boolean) => {
  emit('change', v);
};

const hover = ref(false);
</script>

<style lang="less" scoped>
// :deep() {
// }
</style>
